/**
 * Configuración declarativa del panel lead-gen (el de ecommerce es un layout
 * dedicado en EcomPanel). Las métricas/series se definen como DATOS y se
 * renderizan genéricamente; las que vienen null se ocultan solas.
 */

const METRIC = {
  leads: { key: 'leads', label: 'Leads', format: 'number' },
  qualified_leads: { key: 'qualified_leads', label: 'Leads calificados', format: 'number' },
  cpl: { key: 'cpl', label: 'CPL', format: 'currency' },
  spend: { key: 'spend', label: 'Inversión', format: 'currency' },
  leads_goal: { key: 'leads_goal', label: 'Objetivo leads', format: 'number' },
};

export const PANEL_CONFIGS = {
  lead_gen: {
    metrics: [
      METRIC.leads, METRIC.qualified_leads, METRIC.cpl, METRIC.spend, METRIC.leads_goal,
    ],
    charts: [
      {
        key: 'leads_source',
        title: 'Leads por fuente',
        series: [
          { dataKey: 'leads_meta', label: 'Meta', color: '#3b82f6', yAxisId: 'left' },
          { dataKey: 'leads_google', label: 'Google', color: '#f59e0b', yAxisId: 'left' },
        ],
      },
      {
        key: 'cpl_daily',
        title: 'CPL diario',
        series: [{ dataKey: 'cpl', label: 'CPL', color: '#ef4444', yAxisId: 'left' }],
      },
    ],
    platforms: true,
  },
};

export function panelConfigFor(vertical) {
  return PANEL_CONFIGS[vertical] || PANEL_CONFIGS.lead_gen;
}

/**
 * Bloques/gráficos del panel que una marca puntual puede prescindir.
 * brand.id -> lista de keys ocultas. Lo leen las secciones con isBlockHidden.
 */
export const BRAND_HIDDEN_BLOCKS = {
  1666: ['catalog_stock_inmovilizado'], // Barraca Europa: sin "Stock inmovilizado"
};

export function isBlockHidden(brandId, key) {
  return (BRAND_HIDDEN_BLOCKS[brandId] || []).includes(key);
}

const nf = new Intl.NumberFormat('es-UY', { maximumFractionDigits: 0 });
const nf2 = new Intl.NumberFormat('es-UY', { maximumFractionDigits: 2 });
// Montos chicos (CPC/CPM en monedas de baja denominación) se redondearían a $0/$1.
const nfCur2 = new Intl.NumberFormat('es-UY', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatMetric(value, format) {
  if (value === null || value === undefined) return '—';
  switch (format) {
    case 'currency':
      return `$${nf.format(value)}`;
    case 'currency2':
      return `$${nfCur2.format(value)}`;
    case 'percent':
      return `${nf2.format(value * 100)}%`;
    case 'ratio':
      return `${nf2.format(value)}x`;
    default:
      return nf.format(value);
  }
}
